import * as React from 'react'

class NumberField extends React.Component{
    constructor(props) {
        super(props);
        let getDataMoney = props.getDataMoney;
        this.state = {
            isEditing: false,
            getDataMoney : getDataMoney,
        };
      }
      
      onChange = (event) => {
        let currentEle = event.target;
        let price = currentEle.value;

        price = this.formatNumber(price);
        price = this.clearFormat(price);

        this.props.onChange(price);
      }
      
      formatNumber = (n) => {
        // Format number to 1,234,567
        let formated = n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return formated;
      }

      clearFormat = (n) => {
          let cleard = n.replace(/,/g,'');
          return cleard;
      }

      getOtherMoney = () => {
        return this.props.value != '' ? this.formatNumber(this.props.value  + '') : '';
      }

      handleMoneyFocus(event) {
        let targetDom = event.target;
        let parent = targetDom.closest('.ecf-box-donate__item-price-list-other');
        parent && parent.classList.add('focus');
      }

      handleMoneyBlur(event) {
        let targetDom = event.target;
        let value = targetDom.value;
        let parent = targetDom.closest('.ecf-box-donate__item-price-list-other');
        if(value == '') {
          parent && parent.classList.remove('focus');
        }
        this.props.onBlur();
      }
    
      render() {
        return (
          <div className="ecf-box-donate__typenumber">
              <input
                type="text"
                // placeholder="e.g. S$10"
                value={this.getOtherMoney()}
                onChange={(event) =>{this.onChange(event)}}
                onFocusCapture={(event) =>{ this.handleMoneyFocus(event) }}
                onBlur={(event) =>{ this.handleMoneyBlur(event) }}
              />
          </div>
        );
      }
}
export default NumberField;